import Autocomplete from "@tomickigrzegorz/autocomplete";
import geocoder from "../geocoder";
import { defaults, escape } from "../autocomplete";

export default ({ submitOnSelect = true } = {}) => ({
  selected: null,
  autocomplete: null,
  abortController: null,
  error: null,

  init() {
    const geocode = geocoder(false);

    this.autocomplete = new Autocomplete(this.$refs.input.id, {
      ...defaults("location"),
      onSearch: async ({ currentValue }) => {
        this.abortController?.abort();

        this.abortController = new AbortController();
        this.error = null;

        try {
          const locations = await geocode(
            currentValue,
            {
              includeAddresses: false,
              includeStates: true,
            },
            this.abortController.signal,
          );

          return locations;
        } catch (error) {
          if (error.name === "AbortError") {
            return [];
          }

          console.error(error);
          this.error = error.message;
          return [];
        }
      },

      noResults: ({ template }) => {
        if (!this.error) {
          return template(
            `<div class="px-4 py-2 text-gray-600">No locations match your query.</div>`,
          );
        }

        return template(
          `<div class="px-4 py-2 text-gray-600">Something went wrong loading suggestions (${escape(this.error)}). Please try a different browser or disable browser extensions.</div>`,
        );
      },

      onSubmit: async ({ object }) => {
        this.selected = object;
        await this.$nextTick();

        if (submitOnSelect) {
          this.$refs.input.form.submit();
        }
      },
    });
  },

  destroy() {
    this.autocomplete?.destroy();
    this.abortController?.abort();
  },
});
